/* Plakton South Africa. No dependencies. */
(function () {
  'use strict';

  var routes = window.plaktonRoutes || {};
  var strings = window.plaktonStrings || {};
  var cfg = window.plaktonConfig || {};
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function on(el, evt, fn, opts) { if (el) el.addEventListener(evt, fn, opts); }
  function qs(s, r) { return (r || document).querySelector(s); }
  function qsa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function lockScroll(state) { document.body.classList.toggle('is-locked', !!state); }

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  function focusTrap(container) {
    var sel = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    return function (e) {
      if (e.key !== 'Tab') return;
      var items = qsa(sel, container).filter(function (el) { return el.offsetParent !== null; });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
  }

  function Panel(el) {
    if (!el) return null;
    var trap = focusTrap(el);
    var lastFocused = null;
    function open() {
      lastFocused = document.activeElement;
      el.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      document.addEventListener('keydown', onKey);
      el.addEventListener('keydown', trap);
      window.setTimeout(function () {
        var t = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
        if (t) t.focus();
      }, 80);
    }
    function close() {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      lockScroll(false);
      document.removeEventListener('keydown', onKey);
      el.removeEventListener('keydown', trap);
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    qsa('[data-close]', el).forEach(function (b) { on(b, 'click', close); });
    return { el: el, open: open, close: close, isOpen: function () { return el.classList.contains('is-open'); } };
  }

  /* --------------------------------------------- chrome above the hero */
  // The hero is capped at the viewport minus whatever sits above it, so the
  // whole block lands above the fold. That is the header plus the announcement
  // bar when one is shown, and the bar's height is not a constant: its text
  // wraps on narrow screens and it disappears entirely when left blank. So it
  // gets measured rather than guessed, and re-measured whenever it can change.
  (function chrome() {
    var header = qs('#shopify-section-header');
    var bar = qs('#shopify-section-announcement-bar');
    function set() {
      var h = (header ? header.offsetHeight : 0) + (bar ? bar.offsetHeight : 0);
      if (h > 0) document.documentElement.style.setProperty('--chrome-h', h + 'px');
    }
    set();
    on(window, 'resize', set, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(set);
      if (header) ro.observe(header);
      if (bar) ro.observe(bar);
    }
    // The theme editor swaps sections in and out without a reload.
    document.addEventListener('shopify:section:load', set);
    document.addEventListener('shopify:section:unload', set);
  })();

  /* ------------------------------------------- keep mega panels on screen */
  // The panel is left aligned to the nav item that opened it, which is right
  // until that item sits far enough across that a wide panel would run off the
  // right edge. CSS cannot see where an element is, so nudge it back on open.
  qsa('.nav__item').forEach(function (item) {
    var panel = qs('.mega', item);
    if (!panel) return;
    function place() {
      // Zero the shift before measuring, or each hover compounds the last one.
      panel.style.setProperty('--mega-shift', '0px');
      var gutter = 16;
      var rect = panel.getBoundingClientRect();
      var overflow = rect.right - (window.innerWidth - gutter);
      panel.style.setProperty('--mega-shift', overflow > 0 ? (-overflow) + 'px' : '0px');
    }
    on(item, 'pointerenter', place);
    on(item, 'focusin', place);
    on(window, 'resize', function () { panel.style.removeProperty('--mega-shift'); }, { passive: true });
  });

  /* ------------------------------------------------------------- menu */
  var mobileMenu = Panel(qs('[data-mobile-menu]'));
  qsa('[data-menu-open]').forEach(function (b) { on(b, 'click', function () { if (mobileMenu) mobileMenu.open(); }); });
  qsa('[data-mobile-submenu-toggle]').forEach(function (btn) {
    on(btn, 'click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = expanded;
    });
  });

  /* ----------------------------------------------------------- search */
  var searchOverlay = Panel(qs('[data-search-overlay]'));
  var searchInput = qs('[data-search-input]');
  var searchResults = qs('[data-search-results]');
  var searchIdle = qs('[data-search-idle]');
  var searchLoading = qs('[data-search-loading]');
  var searchHint = qs('[data-search-hint]');

  qsa('[data-search-toggle]').forEach(function (b) { on(b, 'click', function () { if (searchOverlay) searchOverlay.open(); }); });
  document.addEventListener('keydown', function (e) {
    if ((e.metaKey || e.ctrlKey) && e.key && e.key.toLowerCase() === 'k') {
      e.preventDefault();
      if (searchOverlay) searchOverlay.open();
    }
  });

  if (searchOverlay && searchInput && searchResults && routes.predictive_search_url) {
    var searchTimer = null, searchController = null;
    function showIdle() {
      searchResults.hidden = true; searchResults.innerHTML = '';
      if (searchIdle) searchIdle.hidden = false;
      if (searchLoading) searchLoading.hidden = true;
      if (searchHint) searchHint.textContent = 'Start typing to see results';
    }
    function runSearch(term) {
      if (searchController) searchController.abort();
      searchController = new AbortController();
      if (searchIdle) searchIdle.hidden = true;
      if (searchLoading) searchLoading.hidden = false;
      if (searchHint) searchHint.textContent = 'Searching';
      var url = routes.predictive_search_url + '?q=' + encodeURIComponent(term) +
        '&resources[type]=product,collection,page,article&resources[limit]=8' +
        '&resources[options][unavailable_products]=last&section_id=predictive-search';
      fetch(url, { signal: searchController.signal })
        .then(function (r) { return r.text(); })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var inner = doc.querySelector('[data-predictive-inner]');
          searchResults.innerHTML = inner ? inner.innerHTML : '';
          searchResults.hidden = !inner;
          if (searchLoading) searchLoading.hidden = true;
          if (searchHint) searchHint.textContent = 'Press Enter to see all results';
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (searchLoading) searchLoading.hidden = true;
          if (searchHint) searchHint.textContent = 'Search is unavailable right now';
        });
    }
    on(searchInput, 'input', function () {
      var term = searchInput.value.trim();
      window.clearTimeout(searchTimer);
      if (term.length < 2) { if (searchController) searchController.abort(); showIdle(); return; }
      searchTimer = window.setTimeout(function () { runSearch(term); }, 220);
    });
    qsa('[data-search-term]').forEach(function (pill) {
      on(pill, 'click', function (e) {
        e.preventDefault();
        searchInput.value = pill.getAttribute('data-search-term');
        searchInput.focus();
        searchInput.dispatchEvent(new Event('input', { bubbles: true }));
      });
    });
    on(searchInput, 'keydown', function (e) {
      if (e.key !== 'ArrowDown') return;
      var scope = searchResults.hidden ? searchIdle : searchResults;
      if (!scope) return;
      var first = qs('a, button', scope);
      if (first) { e.preventDefault(); first.focus(); }
    });
  }

  /* ------------------------------------------------------- fly to cart */
  function flyToCart(sourceEl) {
    if (reduced || !sourceEl) return Promise.resolve();
    var target = qs('[data-cart-open]') || qs('[data-cart-count]');
    if (!target) return Promise.resolve();
    var img = sourceEl.tagName === 'IMG' ? sourceEl : qs('img', sourceEl);
    if (!img) return Promise.resolve();

    var from = img.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    var ghost = document.createElement('div');
    ghost.className = 'fly-ghost';
    ghost.style.left = from.left + 'px';
    ghost.style.top = from.top + 'px';
    ghost.style.width = from.width + 'px';
    ghost.style.height = from.height + 'px';
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    ghost.appendChild(clone);
    document.body.appendChild(ghost);

    var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
    var dy = (to.top + to.height / 2) - (from.top + from.height / 2);

    return new Promise(function (resolve) {
      var anim = ghost.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '4px' },
        { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.35 - 70) + 'px) scale(0.6)', opacity: 0.95, offset: 0.55 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(0.08)', opacity: 0.2, borderRadius: '50%' }
      ], { duration: 800, easing: 'cubic-bezier(0.55, 0, 0.35, 1)' });
      anim.onfinish = function () {
        ghost.remove();
        var count = qs('[data-cart-count]');
        if (count) {
          count.classList.remove('is-bump');
          void count.offsetWidth;
          count.classList.add('is-bump');
        }
        resolve();
      };
      window.setTimeout(function () { if (ghost.isConnected) { ghost.remove(); resolve(); } }, 1100);
    });
  }

  /* --------------------------------------------------------------- cart */
  var cartDrawer = Panel(qs('[data-cart-drawer]'));

  function refreshCartUI() {
    return fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (htmlText) {
        var doc = new DOMParser().parseFromString(htmlText, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var target = qs('[data-cart-contents]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        qsa('[data-cart-count]').forEach(function (el) {
          // The badge is always visible, zero included, so the header does not
          // reflow by 20px the moment someone adds their first item.
          el.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function addToCart(form, button, sourceEl) {
    var data = new FormData(form);
    if (button) { button.classList.add('loading'); button.setAttribute('aria-disabled', 'true'); }
    var flight = flyToCart(sourceEl);
    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: data
    })
      .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok) {
          var err = qs('[data-cart-error]', form);
          if (err) {
            err.textContent = res.body.description || res.body.message || strings.cartError || 'Could not add to cart.';
            err.hidden = false;
          }
          return;
        }
        return Promise.all([flight, refreshCartUI()]).then(function () {
          if (searchOverlay && searchOverlay.isOpen()) searchOverlay.close();
          // Lets the quick view close itself before the drawer takes over.
          document.dispatchEvent(new CustomEvent('plakton:cart:added'));
          if (cartDrawer) cartDrawer.open();
        });
      })
      .finally(function () {
        if (button) { button.classList.remove('loading'); button.removeAttribute('aria-disabled'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    var typeEl = qs('[data-cart-type]');
    if (typeEl && typeEl.value === 'page') return;
    e.preventDefault();
    var root = form.closest('[data-product-root]') || document;
    addToCart(form, qs('[type="submit"]', form), qs('[data-gallery-main]', root) || qs('.product__main-image', root));
  });

  function changeLine(key, quantity) {
    var scope = qs('[data-cart-contents]') || document.body;
    scope.classList.add('loading');
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCartUI();
      })
      .finally(function () { scope.classList.remove('loading'); });
  }

  // Removing a line slides it out to the right, then closes the gap it leaves,
  // while the request runs underneath. The drawer only re-renders once both
  // the animation and the request are done, so nothing jumps mid-slide.
  function removeLine(key, lineEl) {
    if (!lineEl || reduced || !lineEl.animate || document.body.classList.contains('template-cart')) {
      return changeLine(key, 0);
    }
    lineEl.style.pointerEvents = 'none';
    var request = fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    var slide = lineEl.animate(
      [{ transform: 'translateX(0)', opacity: 1 }, { transform: 'translateX(110%)', opacity: 0 }],
      { duration: 340, easing: 'cubic-bezier(0.55, 0, 0.35, 1)', fill: 'forwards' }
    );
    var motion = slide.finished.then(function () {
      var h = lineEl.offsetHeight;
      var cs = window.getComputedStyle(lineEl);
      lineEl.style.overflow = 'hidden';
      return lineEl.animate(
        [
          { height: h + 'px', paddingTop: cs.paddingTop, paddingBottom: cs.paddingBottom },
          { height: '0px', paddingTop: '0px', paddingBottom: '0px', borderTopWidth: '0px' }
        ],
        { duration: 240, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'forwards' }
      ).finished;
    });
    return Promise.all([request, motion]).then(refreshCartUI, refreshCartUI);
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      removeLine(remove.getAttribute('data-cart-remove'), remove.closest('.cart-line'));
      return;
    }

    var step = e.target.closest('[data-qty-step]');
    if (step) {
      e.preventDefault();
      var wrap = step.closest('.qty');
      var input = qs('input', wrap);
      var dir = parseInt(step.getAttribute('data-qty-step'), 10);
      input.value = Math.max(parseInt(input.min || '0', 10), (parseInt(input.value, 10) || 0) + dir);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var openCart = e.target.closest('[data-cart-open]');
    if (openCart && cartDrawer) { e.preventDefault(); cartDrawer.open(); return; }

    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var card = quick.closest('.card');
      quick.classList.add('loading');
      var flight = flyToCart(card ? qs('.card__img--main', card) : null);
      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(quick.getAttribute('data-quick-add'), 10), quantity: 1 }] })
      })
        .then(function () { return Promise.all([flight, refreshCartUI()]); })
        .then(function () {
          if (searchOverlay && searchOverlay.isOpen()) searchOverlay.close();
          document.dispatchEvent(new CustomEvent('plakton:cart:added'));
          if (cartDrawer) cartDrawer.open();
        })
        .finally(function () { quick.classList.remove('loading'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    var q = parseInt(input.value, 10);
    if (!q) { removeLine(input.getAttribute('data-cart-qty'), input.closest('.cart-line')); return; }
    changeLine(input.getAttribute('data-cart-qty'), q);
  });

  /* ----------------------------------------------------- variant picker */
  function VariantPicker(root) {
    var dataEl = qs('[data-variant-json]', root);
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var form = qs('[data-product-form]', root);
    var idInput = form ? qs('[name="id"]', form) : null;
    var submit = form ? qs('[type="submit"]', form) : null;
    var priceWrap = qs('[data-product-price]', root);
    var skuWrap = qs('[data-product-sku]', root);
    var gallery = qs('[data-gallery]', root);

    function selected() { return qsa('[data-option-input]:checked', root).map(function (i) { return i.value; }); }

    function render() {
      var opts = selected();
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });

      qsa('[data-option-input]', root).forEach(function (input) {
        var index = parseInt(input.getAttribute('data-option-index'), 10);
        var available = variants.some(function (v) {
          return v.available && v.options.every(function (o, i) {
            return i === index ? o === input.value : o === opts[i];
          });
        });
        input.disabled = !available;
      });

      qsa('[data-option-selected]', root).forEach(function (el) {
        el.textContent = opts[parseInt(el.getAttribute('data-option-selected'), 10)] || '';
      });

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? (strings.addToCart || 'Add to cart') : (strings.soldOut || 'Sold out');
      }
      if (priceWrap && variant.price_html) priceWrap.innerHTML = variant.price_html;
      if (skuWrap) skuWrap.textContent = variant.sku || '';
      if (gallery && variant.media_id) {
        var thumb = qs('[data-media-id="' + variant.media_id + '"]', gallery);
        if (thumb) thumb.click();
      }
      // The quick view sits over a collection page, whose URL must not change.
      if (window.history.replaceState && !root.hasAttribute('data-no-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    qsa('[data-option-input]', root).forEach(function (i) { on(i, 'change', render); });
    render();
  }
  qsa('[data-product-root]').forEach(VariantPicker);

  /* ------------------------------------------------------------ gallery */
  qsa('[data-gallery]').forEach(Gallery);
  function Gallery(gallery) {
    var main = qs('[data-gallery-main]', gallery);
    qsa('[data-gallery-thumb]', gallery).forEach(function (thumb) {
      on(thumb, 'click', function () {
        var img = main ? qs('img', main) : null;
        var src = thumb.getAttribute('data-full');
        if (img && src) {
          img.style.opacity = '0';
          window.setTimeout(function () {
            img.src = src;
            var ss = thumb.getAttribute('data-srcset');
            if (ss) img.srcset = ss;
            img.alt = thumb.getAttribute('data-alt') || '';
            img.style.opacity = '1';
          }, reduced ? 0 : 140);
        }
        qsa('[data-gallery-thumb]', gallery).forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });
    if (main) { var mi = qs('img', main); if (mi) mi.style.transition = 'opacity 140ms ease'; }
  }

  /* ------------------------------------------------------------- modals */
  var modals = {};
  qsa('[data-modal]').forEach(function (el) { modals[el.getAttribute('data-modal')] = Panel(el); });
  qsa('[data-modal-open]').forEach(function (btn) {
    on(btn, 'click', function (e) {
      e.preventDefault();
      var m = modals[btn.getAttribute('data-modal-open')];
      if (m) m.open();
    });
  });

  /* ------------------------------------------------- collection facets */
  // Every filter change re-renders the sidebar, form included, so the form is
  // looked up fresh each time and the listener lives on the document. Binding
  // to the original form meant only the first filter click ever applied.
  if (qs('[data-facet-form]')) {
    var facetTimer = null;
    var lastParams = new URLSearchParams(window.location.search);
    lastParams.delete('page');
    lastParams = lastParams.toString();
    function applyFacets() {
      window.clearTimeout(facetTimer);
      var facetForm = qs('[data-facet-form]');
      if (!facetForm) return;
      var params = new URLSearchParams(new FormData(facetForm)).toString();
      // Enter in a price field fires both submit and change. Same filters,
      // same results, so the second request is skipped.
      if (params === lastParams) return;
      lastParams = params;
      var base = facetForm.getAttribute('data-url');
      var url = base + (params ? '?' + params : '');
      var results = qs('[data-collection-results]');
      if (results) results.classList.add('loading');
      fetch(url + (params ? '&' : '?') + 'section_id=' + facetForm.getAttribute('data-section'))
        .then(function (r) { return r.text(); })
        .then(function (htmlText) {
          var doc = new DOMParser().parseFromString(htmlText, 'text/html');
          var fresh = doc.querySelector('[data-collection-results]');
          if (fresh && results) results.innerHTML = fresh.innerHTML;
          var freshFacets = doc.querySelector('[data-facet-inner]');
          var facetTarget = qs('[data-facet-inner]');
          if (freshFacets && facetTarget) facetTarget.innerHTML = freshFacets.innerHTML;
          var freshToggle = doc.querySelector('[data-facets-toggle]');
          var toggle = qs('[data-facets-toggle]');
          if (freshToggle && toggle) toggle.innerHTML = freshToggle.innerHTML;
          window.history.replaceState({}, '', url);
        })
        .finally(function () { if (results) results.classList.remove('loading'); });
    }
    document.addEventListener('change', function (e) {
      if (!e.target.closest('[data-facet-form]')) return;
      window.clearTimeout(facetTimer);
      facetTimer = window.setTimeout(applyFacets, 150);
    });
    // Enter in a field would otherwise submit the form as a full page load.
    document.addEventListener('submit', function (e) {
      if (!e.target.matches('[data-facet-form]')) return;
      e.preventDefault();
      applyFacets();
    });
  }

  var sortSelect = qs('[data-sort]');
  if (sortSelect) {
    on(sortSelect, 'change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* --------------------------------------------- contact form, paper plane */
  qsa('[data-plane-form]').forEach(function (form) {
    on(form, 'submit', function (e) {
      if (form.dataset.sending === 'true') return;
      if (!form.checkValidity()) return;
      e.preventDefault();
      form.dataset.sending = 'true';
      var stage = qs('[data-plane-stage]');
      var fields = qs('[data-plane-fields]', form);
      if (stage && !reduced) {
        if (fields) fields.style.opacity = '0.25';
        stage.hidden = false;
        window.setTimeout(function () { form.submit(); }, 1450);
      } else {
        form.submit();
      }
    });
  });

  /* ------------------------------------------------------- promo popup */
  var promo = Panel(qs('[data-promo]'));
  if (promo && cfg.promoEnabled) {
    var seenKey = 'plakton_promo_seen';
    var dismissed = store(seenKey);
    var fired = false;
    function firePromo() {
      if (fired || dismissed) return;
      fired = true;
      promo.open();
      store(seenKey, String(Date.now()));
    }
    if (!dismissed) {
      window.setTimeout(firePromo, (cfg.promoDelay || 8) * 1000);
      var scrollFire = function () {
        var pct = (window.scrollY + window.innerHeight) / document.body.scrollHeight;
        if (pct > 0.35) { firePromo(); window.removeEventListener('scroll', scrollFire); }
      };
      window.addEventListener('scroll', scrollFire, { passive: true });
    }
    qsa('[data-promo-open]').forEach(function (b) {
      on(b, 'click', function (e) { e.preventDefault(); promo.open(); });
    });

    var promoForm = qs('[data-promo-form]');
    if (promoForm) {
      var subKey = 'plakton_promo_email';
      var showPromoState = function (name) {
        var start = qs('[data-promo-start]');
        var target = qs('[data-promo-' + name + ']');
        if (start && target) { start.hidden = true; target.hidden = false; }
      };
      // Put the shopper back where they were instead of jumping to the form anchor.
      var restoreScroll = function () {
        var y = parseInt(store(subKey + '_y') || '0', 10) || 0;
        if (location.hash && window.history && history.replaceState) {
          history.replaceState(null, '', location.pathname + location.search);
        }
        window.scrollTo(0, y);
        window.addEventListener('load', function () { window.scrollTo(0, y); });
      };
      // Native submit so Shopify's bot protection (CAPTCHA) can attach its token.
      on(promoForm, 'submit', function (e) {
        var input = qs('input[type="email"]', promoForm);
        var email = input ? input.value.trim().toLowerCase() : '';
        if (email && store(subKey) === email) {
          e.preventDefault();
          showPromoState('already');
          return;
        }
        store(subKey + '_pending', email);
        store(subKey + '_y', String(window.scrollY || 0));
        store(seenKey, String(Date.now()));
        var btn = qs('[type="submit"]', promoForm);
        if (btn) btn.classList.add('loading');
      });
      // After the page reloads from the signup, reopen the popup in the right state.
      if (qs('[data-promo-posted]', promoForm)) {
        var pending = store(subKey + '_pending');
        if (pending) store(subKey, pending);
        restoreScroll();
        showPromoState('success');
        promo.open();
      } else if (qs('[data-promo-taken]', promoForm)) {
        restoreScroll();
        showPromoState('already');
        promo.open();
      } else if (qs('[data-promo-error]', promoForm)) {
        restoreScroll();
        promo.open();
      }
    }
  }

  /* ----------------------------------------------------- cookie consent */
  (function cookieConsent() {
    var bar = qs('[data-cookie]');
    if (!bar) return;
    var KEY = 'plakton_consent_v1';
    var fab = qs('[data-cookie-fab]');
    var current = null;
    var hideTimer = null;
    try { current = JSON.parse(store(KEY) || 'null'); } catch (e) { current = null; }

    function apply(prefs, quiet) {
      // Shopify's Customer Privacy API is what actually gates GA4 and pixels.
      try {
        if (window.Shopify && window.Shopify.customerPrivacy && window.Shopify.customerPrivacy.setTrackingConsent) {
          window.Shopify.customerPrivacy.setTrackingConsent({
            analytics: !!prefs.analytics,
            marketing: !!prefs.marketing,
            preferences: !!prefs.preferences,
            sale_of_data: !!prefs.marketing
          }, function () {});
        }
      } catch (e) {}
      store(KEY, JSON.stringify(prefs));
      current = prefs;
      bar.classList.remove('is-in');
      if (quiet) { bar.hidden = true; if (fab) fab.hidden = false; return; }
      window.clearTimeout(hideTimer);
      var hadFocus = bar.contains(document.activeElement);
      hideTimer = window.setTimeout(function () {
        bar.hidden = true;
        if (fab) {
          fab.hidden = false;
          if (hadFocus) fab.focus({ preventScroll: true });
        }
      }, 600);
    }

    // Opens the banner on its main view. Saved choices are ticked in the
    // switches, so "Choose what I share" shows what the visitor picked last time.
    function show(delay) {
      window.clearTimeout(hideTimer);
      if (fab) fab.hidden = true;
      var prefs = qs('[data-cookie-prefs]', bar);
      var actions = qs('[data-cookie-actions]', bar);
      if (prefs) prefs.hidden = true;
      if (actions) actions.hidden = false;
      if (current) {
        var a = qs('[name="consent-analytics"]', bar);
        var m = qs('[name="consent-marketing"]', bar);
        if (a) a.checked = !!current.analytics;
        if (m) m.checked = !!current.marketing;
      }
      bar.hidden = false;
      window.setTimeout(function () { bar.classList.add('is-in'); }, delay);
    }

    // A saved choice is re-sent on every page, and the banner stays closed.
    // The handlers below are still bound so the footer link can reopen it.
    if (current) apply(current, true);
    else show(900);

    on(qs('[data-cookie-accept]', bar), 'click', function () {
      apply({ analytics: true, marketing: true, preferences: true });
    });
    on(qs('[data-cookie-reject]', bar), 'click', function () {
      apply({ analytics: false, marketing: false, preferences: false });
    });
    on(qs('[data-cookie-manage]', bar), 'click', function () {
      var prefs = qs('[data-cookie-prefs]', bar);
      var actions = qs('[data-cookie-actions]', bar);
      if (prefs) prefs.hidden = false;
      if (actions) actions.hidden = true;
    });
    on(qs('[data-cookie-save]', bar), 'click', function () {
      apply({
        analytics: !!(qs('[name="consent-analytics"]', bar) || {}).checked,
        marketing: !!(qs('[name="consent-marketing"]', bar) || {}).checked,
        preferences: true
      });
    });
    // The banner slides up over the spot where the button sat, and the button
    // itself is gone, so the second click of a double click (or a phone's
    // repeat tap) would land on Accept, Essential only or the page behind.
    // Clicks in the half second after opening are swallowed.
    var guardUntil = 0;
    document.addEventListener('click', function (e) {
      if (Date.now() < guardUntil) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-cookie-reopen], a[href$="#cookie-preferences"]');
      if (!b) return;
      e.preventDefault();
      guardUntil = Date.now() + 600;
      show(20);
      var first = qs('[data-cookie-accept]', bar);
      if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 60);
    });
  })();

  /* ----------------------------------------------------- region switcher */
  (function region() {
    var prompt = qs('[data-region-prompt]');
    if (!prompt || !cfg.regionEnabled) return;
    var KEY = 'plakton_region_v1';
    if (store(KEY)) return;

    function dismiss(remember) {
      prompt.classList.remove('is-in');
      if (remember) store(KEY, 'dismissed');
      window.setTimeout(function () { prompt.hidden = true; }, 600);
    }
    on(qs('[data-region-stay]', prompt), 'click', function () { dismiss(true); });
    on(qs('[data-region-go]', prompt), 'click', function () { store(KEY, 'moved'); });

    function show(label, url, flag) {
      var nameEl = qs('[data-region-name]', prompt);
      var linkEl = qs('[data-region-go]', prompt);
      if (nameEl) nameEl.textContent = label;
      if (linkEl) linkEl.href = url;
      // Dim the flag we are not sending them to.
      qsa('[data-region-flag]', prompt).forEach(function (el) {
        var img = qs('.flag', el);
        if (img) img.classList.toggle('flag--muted', el.getAttribute('data-region-flag') !== flag);
      });
      prompt.hidden = false;
      window.setTimeout(function () { prompt.classList.add('is-in'); }, 1400);
    }

    var EU = (cfg.regionEuCountries || '').split(',').map(function (s) { return s.trim().toUpperCase(); });

    function decide(country) {
      if (!country || country === 'ZA') return;
      if (country === 'US' || country === 'CA') {
        show(cfg.regionUsLabel || 'United States', cfg.regionUsUrl, 'us');
      } else if (EU.indexOf(country) !== -1) {
        show(cfg.regionEuLabel || 'Europe', cfg.regionEuUrl, 'eu');
      }
    }

    // Shopify tells us the detected country. Fall back to the browser locale.
    fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        var c = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (c) { decide(String(c).toUpperCase()); return; }
        throw new Error('no country');
      })
      .catch(function () {
        var loc = (navigator.language || '').split('-')[1];
        if (loc) decide(loc.toUpperCase());
      });
  })();

  /* ------------------------------------------------------- shared API */
  // features.js (quick view, wishlist, compare, cart edit) builds on these
  // rather than duplicating them.
  window.Plakton = {
    qs: qs,
    qsa: qsa,
    store: store,
    reduced: reduced,
    Panel: Panel,
    VariantPicker: VariantPicker,
    Gallery: Gallery,
    refreshCartUI: refreshCartUI,
    flyToCart: flyToCart,
    openCart: function () { if (cartDrawer) cartDrawer.open(); },
    closeSearch: function () { if (searchOverlay && searchOverlay.isOpen()) searchOverlay.close(); }
  };
  document.dispatchEvent(new CustomEvent('plakton:ready'));

  /* ---------------------------------------------------- header scrolled */
  var header = qs('.header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    }, { passive: true });
  }
})();
